var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 155,
    viewBox: "0 0 152 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.276 7.71804C9.254 11.9635 22.596 31.2566 35.925 50.5925C57.238 81.5105 59.999 85.9511 58.83 87.4349C58.098 88.3631 45.35 103.179 30.5 120.361C15.65 137.541 3.14 152.221 2.7 152.98C2.054 154.097 3.131 154.361 8.331 154.361H14.762L37.749 127.721C50.392 113.069 61.847 99.7768 63.205 98.1834C64.562 96.589 66.092 95.5434 66.604 95.858C67.116 96.1737 76.517 109.466 87.494 125.397L107.452 154.361H129.726C141.977 154.361 152 154.101 152 153.783C152 153.465 138.698 133.937 122.44 110.389C106.182 86.8394 92.663 67.0085 92.398 66.3204C92.133 65.6312 94.981 61.5192 98.727 57.1822C102.473 52.8442 114.032 39.4367 124.413 27.3866C134.795 15.3365 144.433 4.24542 145.832 2.73866L148.374 0H141.437L134.5 0.000995876L110.034 28.3825C96.578 43.9928 85.533 56.7649 85.49 56.7649C85.446 56.7649 76.656 44.0108 65.955 28.4223L46.5 0.0796701L23.681 0.039835L0.862 0L6.276 7.71804ZM48.722 22.6562C53.617 29.6393 74.807 59.8452 95.811 89.7802C116.815 119.714 134 144.474 134 144.802C134 145.13 129.562 145.398 124.139 145.398H114.278L67.139 78.2689C41.212 41.3478 20 10.874 20 10.5493C20 10.2247 24.46 9.95876 29.911 9.95876H39.822L48.722 22.6562Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.9dba3f1189ff8fbcb364b86363bff926.svg";
export { ForwardRef as ReactComponent };